import api from '@/lib/api';
import type { PaginatedResponse, HousekeepingServiceType } from '@pms/shared';

export interface ListHousekeepingServiceTypesQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
}

export interface CreateHousekeepingServiceTypePayload {
  propertyId: string;
  name: string;
  code: string;
  estimatedMinutes?: number | undefined;
  color?: string | undefined;
  defaultFrequency?: string | undefined;
  isActive?: boolean | undefined;
}

export interface UpdateHousekeepingServiceTypePayload {
  name?: string | undefined;
  code?: string | undefined;
  estimatedMinutes?: number | null | undefined;
  color?: string | null | undefined;
  defaultFrequency?: string | null | undefined;
  isActive?: boolean | undefined;
}

export async function fetchHousekeepingServiceTypes(
  query: ListHousekeepingServiceTypesQuery,
): Promise<PaginatedResponse<HousekeepingServiceType>> {
  const { data } = await api.get<PaginatedResponse<HousekeepingServiceType>>(
    '/housekeeping-service-types',
    {
      params: {
        propertyId: query.propertyId,
        ...(query.search ? { search: query.search } : {}),
        ...(query.isActive !== undefined ? { isActive: query.isActive } : {}),
      },
    },
  );
  return data;
}

export async function createHousekeepingServiceType(
  payload: CreateHousekeepingServiceTypePayload,
): Promise<HousekeepingServiceType> {
  const { data } = await api.post<HousekeepingServiceType>(
    '/housekeeping-service-types',
    payload,
  );
  return data;
}

export async function updateHousekeepingServiceType(
  id: string,
  payload: UpdateHousekeepingServiceTypePayload,
): Promise<HousekeepingServiceType> {
  const { data } = await api.patch<HousekeepingServiceType>(
    `/housekeeping-service-types/${id}`,
    payload,
  );
  return data;
}

export async function deleteHousekeepingServiceType(id: string): Promise<void> {
  await api.delete(`/housekeeping-service-types/${id}`);
}
